import coreAPIInstance from "./coreApiInstance";

export const contentIngestionAPIs = {
  validateContentIngestion: ({ payload }) => coreAPIInstance.post(`/api/v1/content-ingestion/validate`, payload),
  processContentIngestion: ({ payload }) => coreAPIInstance.post(`/api/v1/content-ingestion/process`, payload),
  listAllContentIngestion: ({ payload }) => coreAPIInstance.post(`/api/v1/content-ingestion/list`, payload),
  cancelContentIngestion: ({ payload }) => coreAPIInstance.post(`/api/v1/content-ingestion/cancel`, payload),
};
